function ScrollContainer(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}


	/**
	 * Scroll containers to center
	 */
	function scrollToCenter() {
		var offset = Math.round((_this.container[0].scrollWidth / 2) - (_this.container.width() / 2));
		_this.container.scrollLeft(offset);
	}

	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			if(_this.container.data('scrollCenter')){
				scrollToCenter();
				_this.container.addClass('ready');
			}

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
